module.exports = "<p>\r\n  shop-single-product-page works!\r\n</p>\r\n"